import React, {useState, useEffect, useContext} from 'react'
import {get,sortBy,isEqual,partition,omit} from 'lodash-es'
import Seletor from '../Seletor';
import useFetchData from '../../crud/useFetchData';
import {proto,url} from '../../Helpers/api';
import styled, {css} from 'styled-components';
import {
  Button,
  Card,
  TextField,
  FormControlLabel,
  Switch,
  Dialog
} from '@material-ui/core';
import DataTable from '../../Common/DataTable';

let rubricasKeys = [
  "I_EVENTOS",
  "NOME",
  "CODIGO_ESOCIAL",
  "CODIGO_INCIDENCIA_IRRF_ESOCIAL",
  "CODIGO_INCIDENCIA_INSS_ESOCIAL",
  "CODIGO_INCIDENCIA_FGTS_ESOCIAL",
  "CODIGO_INCIDENCIA_SINDICAL_ESOCIAL",
]

const colorRow = props => props.r % 2 ? css`
  color: red;
` : css`
  color: blue;
`
const SetaBorda = styled.div`
  width: 100%;
  background: yellow;
  ${colorRow};
`
const ColorRow = styled.span`
  ${colorRow};
`

const MarcaRepetido = (repetidos,idx) => (props) => {
  let { r } = props;
  r = r - 1;
  if (repetidos[r].includes(idx))
    return <SetaBorda {...props} />
  return <ColorRow {...props} />
}

const marcaRepetidos = (arr, ignoraCod=false) => {
  let t = []
  arr.forEach((el1,i) => {
    if (i % 2) {
      let el2 = arr[i-1];
      let x = rubricasKeys.map((key, idx) => {
        if (ignoraCod && idx === 2) return null
        if (el1[key] !== el2[key]) return idx
        return null
      }).filter(o=>o)
      t.push(x)
      t.push(x)
    }
  })
  return t
}

const Top = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  & > * {
    margin-right: 10px;
  }
`

const Card_ = styled(Card)`
  margin: 8px 2px;
  padding: 8px 2px;
`

const withIndex = (fn) => {
  let index = 0
  return (thing) => fn(thing, index++)
}

const Cor = styled.span`
  color: ${props => props.c};
`

const RubricasContext = React.createContext();

export default function RubricasMain(props) {
  const [ empresa, setEmpresa ] = useState(null);
  const [ outroCod, setOutroCod ] = useState(null);
  const [ busca, setBusca ] = useState(false);
  const [ tabela, setTabela ] = useState(null);
  const [ listaIds, setListaIds ] = useState(null);
  return (
    <RubricasContext.Provider value={{
      empresa, setEmpresa,
      outroCod, setOutroCod,
      busca, setBusca,
      tabela, setTabela,
      listaIds, setListaIds
    }}>
      <Rubricas
        {...props}
      />
    </RubricasContext.Provider>
  )
}

function Rubricas(props) {
  const { empresas } = props.data;
  const {empresa, setEmpresa, outroCod, setOutroCod, busca, setBusca} = useContext(RubricasContext);
  const emp = get(empresa,"value")
  const [ opt, setOpt ] = useState([]);
  // gera lista de opções do seletor de empresas
  useEffect(() => {
    setOpt(sortBy(empresas,'Apelido').map(e => {
      let label = e.Cidade ? ` - ${e.Cidade} ` : " "
      label = e.Apelido + label + `(${e.Codigo})`
      return { value: e.Codigo, label, sublabel: e.RazaoSocial }
    }))
  }, [empresas])
  return (
    <>
      <Top>
        <div style={{
          flex: "0 0 500px"
        }}>
          <Seletor
            fullWidth
            label={"Empresa"}
            onChange={e => { setBusca(false); setEmpresa(e); }}
            value={empresa}
            placeholder="Selecione a empresa"
            suggestions={opt}
          />
        </div>
        <RubricasEmpresaSelecionada 
          empresaId={emp}
          {...props} 
        />
      </Top>
    { emp && (
      <Card_>
        <Top>
          <OutraRubrica 
            {...{outroCod, setOutroCod, busca, setBusca}}
          />
        </Top>
        { busca && (
          <BuscaRubrica />
        )}
      </Card_>
    )}
    </>
  )
}

function BuscaRubrica (props) {
  const { tabela, outroCod, listaIds } = useContext(RubricasContext);
  const [ ignorarCodEsocial, setIgnorarCodEsocial ] = useState(true)
  const [ repetidos, setRepetidos ] = useState(true)
  const [ showData, setShowData ] = useState([])
  const [ mostra1, setMostra1 ] = useState(false)
  const [ mostra2, setMostra2 ] = useState(false)
  let codTabela1 = tabela;
  let codTabela2 = outroCod;
  if (codTabela1 == codTabela2) return <div>Os códigos das tabelas são iguais! <b>[{codTabela1}]</b></div>
  let lista = listaIds;
  let fUrl = `${proto}://${url}/esocial/rubricas/compara/${codTabela1}/${codTabela2}`
  let opt = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({lista})
  }
  const f = useFetchData(fUrl, { opt })
  let dados = {};
  if (get(f,"isFinished")) {
    dados = get(f,"data", {});
  }
  let { diff1=[], diff2=[] } = dados;
  useEffect(() => {
    if (ignorarCodEsocial) {
      let toShow = dados.toShow || [];
      let tmp = toShow;
      tmp = tmp.map(e => omit(e, "CODIGO_ESOCIAL"));
      const [tmpA, tmpB] = partition(tmp, withIndex((o,i)=> i % 2));
      let keys = tmpA.filter((e,i) => (!isEqual(e, tmpB[i]))).map(e => e.I_EVENTOS)
      toShow = toShow.filter(e => keys.includes(e.I_EVENTOS))
      setShowData(toShow)
      setRepetidos(marcaRepetidos(toShow, ignorarCodEsocial))
    } else {
      let toShow = dados.toShow || []
      setShowData(toShow)
      setRepetidos(marcaRepetidos(toShow))
    }
  }, [ ignorarCodEsocial, dados ])
  if (get(f,"isLoading")) return <div>Carregando dados...</div>
  if (get(f,"error")) return <div>Erro ao carregar dados!</div>
  return (
    <>
    <Card_>
      <div>
        {diff1.length} códigos de rúbricas existentes somente na <Cor c="red">tabela <b>1 [{codTabela1}]</b></Cor>
        {Boolean(diff1.length) && (
          <>
            <ToggleShow onClick={()=>setMostra1(!mostra1)}>{mostra1 ? "Ocultar" : "Ver"}</ToggleShow>
            {mostra1 && (
              <div>
              {diff1.map(i => (
                <div style={{color:"gray",paddingLeft:"5px"}}>
                  {i.I_EVENTOS} - {i.NOME}
                </div>
              ))}
              </div>
            )}
          </>
        )}
      </div>
      <div>
        {diff2.length} códigos de rúbricas existentes somente na <Cor c="blue">tabela <b>2 [{codTabela2}]</b></Cor>
        {Boolean(diff2.length) && (
          <>
            <ToggleShow onClick={()=>setMostra2(!mostra2)}>{mostra2 ? "Ocultar" : "Ver"}</ToggleShow>
            {mostra2 && (
              <div>
              {diff2.map(i => (
                <div style={{color:"gray",paddingLeft:"5px"}}>
                  {i.I_EVENTOS} - {i.NOME}
                </div>
              ))}
              </div>
            )}
          </>
        )}
      </div>
      <div>
        <FormControlLabel
          control={
            <Switch
              checked={ignorarCodEsocial}
              onChange={()=>setIgnorarCodEsocial(!ignorarCodEsocial)}
            />
          }
          label={`Ignorar diferença de Código E-Social (${showData.length / 2} diferenças, mostradas abaixo)`}
        />
      </div>
      <div style={{
        maxWidth: "602px"
      }}>
        <DataTable 
          width={"inherit"}
          cols={[
            "50px",
            "260px",
            "50px",
            "60px",
            "60px",
            "60px",
            "60px",
          ]}
          comps={{
            "I_EVENTOS": ColorRow,
            "NOME": MarcaRepetido(repetidos,1),
            "CODIGO_ESOCIAL": MarcaRepetido(repetidos,2),
            "CODIGO_INCIDENCIA_IRRF_ESOCIAL": MarcaRepetido(repetidos,3),
            "CODIGO_INCIDENCIA_INSS_ESOCIAL": MarcaRepetido(repetidos,4),
            "CODIGO_INCIDENCIA_FGTS_ESOCIAL": MarcaRepetido(repetidos,5),
            "CODIGO_INCIDENCIA_SINDICAL_ESOCIAL": MarcaRepetido(repetidos,6),
          }}
          data={showData}
          dataIdx={rubricasKeys}
          title={[
            "Código",
            "Rúbrica",
            "Código E-Social",
            "Cod Incid IRRF E-Social",
            "Cod Incid INSS E-Social",
            "Cod Incid FGTS E-Social",
            "Cod Incid Sindical E-Social",
          ]}
        />
      </div>
    </Card_>
    <CardFixed>
      <Cor as="div" c="red">Tabela 1 - {codTabela1}</Cor>
      <Cor as="div" c="blue">Tabela 2 - {codTabela2}</Cor>
    </CardFixed>
    </>
  )
}

const CardFixed = styled(Card)`
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px;
  width: auto;
  height: auto;
`

const ToggleShow = styled.span`
  margin-left: 10px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    font-weight: bold;
    text-decoration: underline;
  }
`

function OutraRubrica (props) {
  const {outroCod, setOutroCod, busca, setBusca} = props;
  return (
    <>
      <TextField
        style={{ width: "240px"}}
        label="Comparar com"
        placeholder="Digite o código de tabela..."
        value={outroCod}
        onChange={e => {
          setBusca(false);
          setOutroCod(e.target.value);
        }}
      />
      <Button 
        onClick={()=>setBusca(true)}
        variant="outlined"
      >
        Buscar diferenças
      </Button>
    </>
  )
}

function RubricasEmpresaSelecionada (props) {
  const {empresaId} = props;
  if (!empresaId) return null;
  const [ modal, setModal ] = useState(false);
  let fUrl = `${proto}://${url}/esocial/rubricas/${empresaId}`
  const f = useFetchData(fUrl)
  let dados = {};
  if (get(f,"isFinished")) {
    dados = get(f,"data", {});
  }
  let { listaIds:_ids=[], lista={}, TabelaRubrica=" " } = dados;
  const { tabela, setTabela, listaIds, setListaIds } = useContext(RubricasContext);
  useEffect(() => { setTabela(TabelaRubrica) }, [ TabelaRubrica ])
  useEffect(() => { setListaIds(_ids) }, [ _ids ])
  TabelaRubrica = TabelaRubrica && TabelaRubrica.toString();
  if (get(f,"isLoading")) return <div>Carregando dados...</div>
  if (get(f,"error")) return <div>Erro ao carregar dados!</div>
  let listaEventos = listaIds.map(id_ => lista[id_])
  return (
    <>
    <div>
      <TextField
        style={{ width: "138px"}}
        label="Tabela de Rúbricas"
        value={tabela}
        InputProps={{
          readOnly: true,
        }}
      />
    </div>
    <div>
      <Button 
        variant="outlined"
        color="primary" 
        onClick={()=>setModal(true)}
      >
        Ver rúbricas ({listaIds.length})
      </Button>
      <Dialog
        open={Boolean(modal)}
        onClose={()=>setModal(false)}
        scroll="body"
        fullWidth
        maxWidth="sm"
      >
        <div style={{
          paddingTop: "10px",
          paddingBottom: "10px",
          display:"flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column"
        }}>
          <div>Rubricas utilizadas pela empresa:</div>
          <DataTable 
            width={"inherit"}
            cols={["390px", "75px", "50px"]}
            title={["Evento", "CodEvento", "Qtde"]}
            data={listaEventos}
            dataIdx={["Evento", "CodEvento", "Qtde"]}
          />
        </div>
      </Dialog>
    </div>
    </>
  )
}

